const items = [
  "Financial Foundation",
  "Strategic Finance",
  "Investor Readiness",
  "Venture Building",
  "Capital Network",
];

const Marquee = () => {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="relative w-full overflow-hidden bg-acid border-y border-ink py-4"
    >
      <div className="flex w-max animate-marquee">
        {doubled.map((it, i) => (
          <div
            key={i}
            className="flex items-center font-mono text-sm uppercase tracking-[0.18em] text-ink px-8"
          >
            <span>{it}</span>
            <span className="ml-8 h-1.5 w-1.5 bg-ink rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
